import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=39f9f8b2&scoped=true"
import script from "./VehicleInfo.vue?vue&type=script&lang=js"
export * from "./VehicleInfo.vue?vue&type=script&lang=js"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&id=39f9f8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9f8b2",
  null
  
)

export default component.exports